export default {
  nav: {
    collection: '收藏',
    scan: '掃描',
    cards: '卡牌表',
    profile: '帳戶',
  },
  common: {
    all: '全部',
    search: '搜尋',
    cancel: '取消',
    confirm: '確認',
    noData: '暫無資料',
    success: '成功',
    loading: '加載中...',
    ownedOnly: '僅顯示已擁有',
    edit: '編輯',
    delete: '刪除',
    save: '保存',
    langJa: '日語',
    langEn: '英語',
  },
  toast: {
    networkError: '網路錯誤，請檢查連線',
    timeout: '請求逾時，請重試',
    invalidRequest: '請求無效',
    sessionExpired: '登錄已過期，請重新登錄',
    accessDenied: '存取被拒',
    notFound: '資源不存在',
    invalidParams: '參數錯誤',
    tooManyRequests: '請求過於頻繁，請稍候',
    serverError: '伺服器錯誤，請稍後再試',
    loginRequired: '請先登錄',
    addSuccess: '已加入收藏',
    removeSuccess: '已移除收藏',
    quantityUpdated: '數量已更新',
    saveSuccess: '儲存成功',
    signOutSuccess: '已登出',
    searchEmpty: '請輸入卡牌編號',
    uploadSuccess: '上傳成功',
    notCamera: '無法存取攝像頭，請確認權限。',
    firstCard: '已經是第一張卡片了',
    lastCard: '已經是最後一張卡片了',
    emailEmpty: '請輸入電子郵件地址',
    emailInvalid: '請輸入有效的電子郵件地址',
    codeEmpty: '請輸入 6 位驗證碼',
    addSuccess: '已添加到收藏',
  },
  signin: {
    subtitle: '航海王集卡追蹤器',
    emailLabel: '電子郵件',
    emailPlaceholder: 'captain@grandline.com',
    verificationCode: '驗證碼',
    send: '發送',
    resend: '重新發送',
    signIn: '登錄',
    autoRegister: '新用戶將自動完成註冊',
  },
  collection: {
    searchPlaceholder: '搜尋卡牌、系列、編號…',
    searchedCards: '搜尋結果',
    totalValue: '收藏總價值',
    totalCards: '卡牌總數',
    sortHighToLow: '價格：由高到低',
    sortLowToHigh: '價格：由低到高',
    recentlyAdded: '最新收藏',
    guestTitle: '開始你的收藏之旅',
    guestDesc: '登錄後即可追蹤、管理並評估你的卡牌收藏價值',
    guestFeature1: '記錄每一張你擁有的卡牌',
    guestFeature2: '即時監控市場價格動態',
    guestFeature3: '使用鏡頭快速掃描識別卡牌',
    emptyTitle: '您的收藏為空',
    emptyDesc: '透過掃描或搜尋卡牌，建立您的收藏',
    scanCards: '掃描卡牌',
    searchCards: '搜尋卡牌',
    gradedValue: '評級卡價值',
    ungradedValue: '裸卡價值',
    filter: '篩選',
    filterTitle: '篩選與排序',
    sortBy: '排序方式',
    language: '語言',
    langJP: '日語',
    langEN: '英語',
    cardType: '卡牌類型',
    cardTypeAll: '全部',
    cardTypeGraded: '評級卡',
    cardTypeRaw: '裸卡',
    resetFilter: '重置',
    applyFilter: '套用篩選',
    plLabel: '盈虧',
  },
  cardDetail: {
    title: '卡牌詳情',
    cardId: '卡牌編號',
    rarity: '稀有度',
    language: '語言',
    version: '版本',
    type: '類型',
    foil: '閃卡',
    yourHolding: '我的持有',
    owned: '持有數量',
    market: '市場價格',
    lastUpdated: '最後更新',
    ungradedPrice: '裸卡市價 (USD)',
    totalValue: '總收藏價值(USD)',
    addToCollection: '添加到收藏',
    addCard: '添加卡牌',
    cardCondition: '品相',
    selectCondition: '選擇品相',
    totalPaid: '總買入價',
    pricePerCard: '單張買入價',
    qtyMinError: '數量至少為 1',
    totalPaidRequired: '請輸入總買入金額',
    profitLabel: '盈虧',
    gradeHint: '*新增後不能更改評級',
    remove: '移除'
  },
  scan: {
    title: '掃描',
    manual: '手動輸入',
    alignCard: '將卡牌對準框內',
    scanCard: '掃描卡牌以識別',
    searchCards: '搜尋卡牌',
    scanBtn: '掃描',
    pointCamera: '對準卡牌 · 保持穩定',
    unidentified: '未能識別卡牌',
    cardsIdentified: '張卡牌已識別',
    scanSuccess: '識別成功',
    cardLanguage: '卡牌語言',
    cardId: '卡牌編號',
    cardIdPlaceholder: '例：OP01-060',
    tapToCapture: '點擊下方按鈕拍照',
    takePhoto: '拍攝照片',
    fromAlbum: '從相簿選擇',
    clear: '清空',
    qty: '數量',
  },
  cards: {
    searchPlaceholder: '搜尋系列…',
    searchInSet: '搜尋卡牌…',
    allSets: '全部系列',
    of: 'of',
  },
  profile: {
    email: '電子郵件',
    language: '語言',
    langEn: 'English',
    langZhTW: '繁體中文',
    editUsername: '修改用戶名',
    usernamePlaceholder: '請輸入用戶名',
    saveUsername: '儲存',
    editAvatar: '更換頭像',
    signOut: '登出',
    guest: '開始你的收藏之旅',
    guestDesc: '登錄後即可追蹤、管理並評估你的卡牌收藏價值',
    feature1: '追蹤並管理你的卡牌收藏',
    feature2: '即時監控市場價格動態',
    feature3: '使用鏡頭快速掃描識別卡牌',
  },
  report: {
    title: '反饋問題',
    imageIssue: '圖片異常',
    priceIssue: '價格異常',
    missingCard: '缺少卡牌',
    other: '其他',
    placeholder: '請描述該問題。',
    submit: '提交',
    successToast: '反饋成功',
    feedback: '意見反饋',
  },
}
